
export default {
    name: 'historique-examen-clinique',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}


